(() => {
  function initialize(section) {
    if (section.dataset.visualizerPageReady === 'true') return;
    section.dataset.visualizerPageReady = 'true';
    const input = section.querySelector('[data-visualizer-page-search]');
    const cards = Array.from(section.querySelectorAll('[data-visualizer-page-card]'));
    const empty = section.querySelector('[data-visualizer-page-empty]');
    const loadMore = section.querySelector('[data-visualizer-page-load-more]');
    const initialCount = Number.parseInt(section.dataset.initialCount, 10) || 8;
    const loadCount = Number.parseInt(section.dataset.loadCount, 10) || 8;
    let visibleLimit = initialCount;
    if (!input) return;

    const render = (resetLimit) => {
      if (resetLimit) visibleLimit = initialCount;
      const query = input.value.trim().toLocaleLowerCase();
      const matches = cards.filter((card) => !query || card.dataset.searchText.includes(query));
      cards.forEach((card) => {
        card.hidden = true;
      });
      matches.forEach((card, index) => {
        card.hidden = !query && index >= visibleLimit;
      });
      if (empty) empty.hidden = matches.length !== 0;
      if (loadMore) {
        loadMore.hidden = Boolean(query) || matches.length <= visibleLimit;
      }
    };

    input.addEventListener('input', () => render(true));
    if (loadMore) {
      loadMore.addEventListener('click', () => {
        visibleLimit += loadCount;
        render(false);
        const firstNewCard = cards.find((card, index) => index >= visibleLimit - loadCount && !card.hidden);
        if (firstNewCard) firstNewCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }
    render(true);
  }

  function initializeAll(scope) {
    scope.querySelectorAll('[data-heikoa-visualizer-page]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(document));
  } else {
    initializeAll(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
